import { render, staticRenderFns } from "./PlayCircleOutlineIcon.vue?vue&type=template&id=2d1e6ad4"
import script from "./PlayCircleOutlineIcon.vue?vue&type=script&lang=js"
export * from "./PlayCircleOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports